import React, { useState, useEffect } from "react";
import styles from "./constructCalender.module.scss";
import { Typography } from "@mui/material";
import { isEmpty, isNil } from "lodash";
import { CustomTooltip } from "../muhurtham/muhurtham";
import Brightness1Icon from "@mui/icons-material/Brightness1";
import LensOutlinedIcon from "@mui/icons-material/LensOutlined";
import { Dialog, DialogTitle, Grid, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import toast, { Toaster } from "react-hot-toast";
import ToastError from "../toast/toastError";
import { apiRequest, catchErrorMessageHandler } from "../../../infrastructure/backendService";
import { CalenderBackendResponseProps } from "../../../infrastructure/GlobalContextProvider";
import { CommonButton } from "../StyledComponents/StyledFields";
import ScheduleEventsTemplate from "../../devotee/dashboard/events/scheduleEventsTemplate";
import constants from "../../../config/constants.json";
import apiPath from "../../../config/apiPaths.json";
import { AxiosResponse, AxiosError } from "axios";
import ErrorPopup from "../ErrorPopup";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
interface CalenderDataProps {
  year: number;
  month: string | undefined;
  backendResponseList: CalenderBackendResponseProps[];
}

const CalenderData = (props: CalenderDataProps) => {
  const currentDate = new Date();
  const [selectedDate, setSelectedDate] = useState(formatDate(currentDate));
  const [selectedthithi, setSelectedThithi] = useState<string | null>("");
  const [selectedNakshatram, setSelectedNakshatram] = useState<
    string | null | undefined
  >("");
  const [selectedRahukalam, setSelectedRahukalm] = useState<
    string | null | undefined
  >("");
  const [selectedDurmuhurthum, setSelectedDurmuhurtum] = useState<
    string | null | undefined
  >("");
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [todayScheduleList, setTodayScheduleList] = useState<string[] | []>([]);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    apiRequest({
      method: "POST",
      endpoint: apiPath.dailyTempleActivity,
      params: {
        scheduleDate: selectedDate,
      },
    })
      .then((res) => {
        setTodayScheduleList(res.data.dailyActivities);
      })
      .catch((err) => {
        console.log(err);
        toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
          duration: constants.TOAST_POPUP_DURATION,
        });
      });
  }, [selectedDate]);

  function formatDate(date: Date): string {
    const day = date?.getDate();
    const month = date?.getMonth() + 1;
    const year = date?.getFullYear();

    const formattedDay = day < 10 ? `0${day}` : day;
    const formattedMonth = month < 10 ? `0${month}` : month;

    return `${formattedMonth}/${formattedDay}/${year}`;
  }

  const handleClose = (): void => {
    setIsOpen(false);
  };
  const handleClick = (buttonType: any) => {
    if (buttonType.toLowerCase() === "events") {
      setIsOpen(true);
    }
  };

  const handlePrint = () => {
    window.print();
  };

  const WeeksForMobileView = [
    {
      week: "Sun",
    },
    {
      week: "Mon",
    },
    {
      week: "Tue",
    },
    {
      week: "Wed",
    },
    {
      week: "Thu",
    },
    {
      week: "Fri",
    },
    {
      week: "Sat",
    },
  ];
  
  const Weeks = [
    {
      week: "Sunday",
    },
    {
      week: "Monday",
    },
    {
      week: "Tuesday",
    },
    {
      week: "Wednesday",
    },
    {
      week: "Thursday",
    },
    {
      week: "Friday",
    },
    {
      week: "Saturday",
    },
  ];

  const Months = [
    {
      month: "January",
    },
    {
      month: "February",
    },
    {
      month: "March",
    },
    {
      month: "April",
    },
    {
      month: "May",
    },
    {
      month: "June",
    },
    {
      month: "July",
    },
    {
      month: "August",
    },
    {
      month: "September",
    },
    {
      month: "October",
    },
    {
      month: "November",
    },
    {
      month: "December",
    },
  ];

  const getMonthArray = (
    year: number,
    month: number,
    eventsData: CalenderBackendResponseProps[]
  ) => {
    const firstDay = new Date(year, month, 1);
    const days = new Date(year, month + 1, 0).getDate();
    const daysInMonth = new Date(year, month + 1, 0).getDate(); // Get the number of days in the month
    const startOffset = firstDay.getDay();

    const monthArray = [];
    let day = 1;
    let dayCounter = 1; // This will be used to fill in the actual days of the month

    for (let week = 0; week < 6; week++) {
      const weekArray = [];
      for (let dayOfWeek = 0; dayOfWeek < 7; dayOfWeek++) {
        if (week === 0 && dayOfWeek < startOffset) {
          weekArray.push(null);
        } else if (dayCounter <= daysInMonth) {

          // Process actual days of the month
          const currentDateStr = `${year}-${String(month + 1).padStart(2, '0')}-${String(dayCounter).padStart(2, '0')}`;
          const eventData = eventsData.find(event => event.date === currentDateStr);
          // If there are events, add them to the day
          if (eventData) {
            weekArray.push({
              ...eventData,
              dayCounter,
            });
          } else {
            weekArray.push({
              dayCounter,
              monthName:null,
              thithi: null,
              thithiTime: null,
              nakshtram: null,
              nakshtramTime: null,
              rahukalam: null,
              durmuhurtham: null,
              isAnySpecialEvent: null,
              specialEventName: null,
              isPoornima: null,
              isAmavasya: null,
            });
          }

          dayCounter++;
        } else {
          weekArray.push(null);
        }
      }
      monthArray.push(weekArray);
    }

    return monthArray;
  };

  const monthArray = getMonthArray(
    Number(props.year),
    Months.findIndex((m) => m.month === props?.month),
    props.backendResponseList
  );

  const WeeksConatiner = () => {
    return (
      <thead>
        <tr className={styles.weeksConatiner}>
          {Weeks.map((item, i) => (
            <th key={i} className={styles.singleWeekFeild}>
              {item.week}
            </th>
          ))}
        </tr>
      </thead>
    );
  };

  const WeeksConatinerForMobileView = () => {
    return (
      <thead>
        <tr className={styles.weeksConatiner}>
          {WeeksForMobileView.map((item, i) => (
            <th key={i} className={styles.singleWeekFeild}>
              {item.week}
            </th>
          ))}
        </tr>
      </thead>
    );
  };

  console.log(monthArray, "monthArray");

  const tableMainCalenderContent = () => {
    return (
      <tbody className={styles.onlyCalenderContainer}>
        {monthArray.map((week, index: number) => (
          <tr key={index}>
            {week.map((day, dayIndex: number) => (
              <td key={dayIndex}>
                {!isNil(day?.dayCounter) ? (
                  <div
                    onClick={() => {
                      const monthIndex = Months.findIndex(
                        (m) => m.month === props.month
                      );
                      const monthNumber = monthIndex + 1;
                      const formattedDay = day?.dayCounter.toString().padStart(2, "0");
                      const formattedMonth = monthNumber
                        .toString()
                        .padStart(2, "0");
                      const formattedYear = props.year;
                      handleClick("events");
                      setSelectedDate(
                        `${formattedMonth}/${formattedDay}/${formattedYear}`
                      );
                      if (
                        !isNil(day) &&
                        !isNil(day?.thithi) &&
                        !isNil(day?.thithiTime)
                      ) {
                        setSelectedThithi(day?.thithi + " " + day?.thithiTime);
                      } else if (!isNil(day) && !isNil(day?.thithi)) {
                        setSelectedThithi(day?.thithi);
                      } else if (!isNil(day) && !isNil(day?.thithiTime)) {
                        setSelectedThithi(day?.thithiTime);
                      } else {
                        setSelectedThithi("");
                      }
                      if (
                        !isNil(day) &&
                        !isNil(day?.nakshtram) &&
                        !isNil(day?.nakshtramTime)
                      ) {
                        setSelectedNakshatram(
                          day?.nakshtram + " " + day?.nakshtramTime
                        );
                      } else if (!isNil(day) && !isNil(day?.nakshtram)) {
                        setSelectedNakshatram(day?.nakshtram);
                      } else if (!isNil(day) && !isNil(day?.nakshtramTime)) {
                        setSelectedNakshatram(day?.nakshtramTime);
                      } else {
                        setSelectedNakshatram("");
                      }
                      setSelectedRahukalm(day?.rahukalam);
                      setSelectedDurmuhurtum(day?.durmuhurtham);
                    }}
                    className={`${styles.singleDateContainer} ${day?.isAnySpecialEvent ? styles.selectedDate : ""
                      }`}
                  >
                    <div className={styles.poornimaContainer}>
                      {!isNil(day?.isPoornima) && day?.isPoornima ? (
                        <LensOutlinedIcon />
                      ) : (
                        ""
                      )}
                      {!isNil(day?.isAmavasya) && day?.isAmavasya ? (
                        <Brightness1Icon sx={{ color: "black" }} />
                      ) : (
                        ""
                      )}
                    </div>
                    <div>
                      <Typography
                        className={styles.date}
                        style={{
                          color: day?.isAnySpecialEvent ? "#fff" : "#882e14",
                        }}
                      >
                        {day?.dayCounter}
                      </Typography>

                      {day?.isAnySpecialEvent ? (
                        <CustomTooltip
                          title={day?.monthName}
                          placement="top-start"
                          arrow
                        >
                          <Typography
                            className={styles.eventName}
                            style={{
                              color: day?.isAnySpecialEvent
                                ? "#fff"
                                : "#882e14",
                            }}
                          >
                            {day &&
                              day?.monthName}
                          </Typography>
                        </CustomTooltip>
                      ) : (
                        ""
                      )}


                      {!isNil(day?.thithi) || !isEmpty(day?.thithi) ? (
                        <Typography
                          className={styles.thithiAndNakshtra}
                          style={{
                            color: day?.isAnySpecialEvent ? "#fff" : "#313131",
                          }}
                        >
                          {day?.thithi} {day?.thithiTime}
                        </Typography>
                      ) : (
                        ""
                      )}

                      {!isNil(day?.nakshtram) || !isEmpty(day?.nakshtram) ? (
                        <Typography
                          className={styles.thithiAndNakshtra}
                          style={{
                            color: day?.isAnySpecialEvent ? "#fff" : "#313131",
                          }}
                        >
                          {day?.nakshtram} {day?.nakshtramTime}
                        </Typography>
                      ) : (
                        ""
                      )}
                      
                      {day?.isAnySpecialEvent ? (
                        <CustomTooltip
                          title={day?.specialEventName}
                          placement="top-start"
                          arrow
                        >
                          <Typography
                            className={styles.eventName}
                            style={{
                              color: day?.isAnySpecialEvent
                                ? "#fff"
                                : "#882e14",
                            }}
                          >
                            {day &&
                              day?.specialEventName &&
                              day?.specialEventName.length > 10
                              ? day?.specialEventName.slice(0, 10) + "...."
                              : day?.specialEventName}
                          </Typography>
                        </CustomTooltip>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                ) : null}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    );
  };

  const dialogPopUp = () => {
    return (
      <Dialog
        open={isOpen}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="xl"
        PaperProps={{
          style: {
            maxWidth: "759px",
            height: "calc(100% - 64px)",
            margin: "32px",
            borderRadius: "16px",
            background: "#FFF",
            maxHeight: "700px",
            flexDirection: "column",
          },
        }}
      >
        <DialogTitle
          sx={{
            fontWeight: 700,
            fontSize: 24,
            color: "white",
            borderTopRightRadius: "16px",
            borderTopLeftRadius: "16px",
            backgroundColor: "#882E14",
          }}
        >
          {selectedDate}
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 24,
              top: 12,
              color: (theme: any) => theme.palette.grey[500],
            }}
          >
            <CloseIcon sx={{ color: "white" }} />
          </IconButton>
        </DialogTitle>
        <div className={styles.eventDetails}>
          <CommonButton onClick={handlePrint} sx={{ float: "right" }} className={styles.printHidden}>
            Print
          </CommonButton>
          <div>
            <Grid>
              <Typography>
                <span className={styles.nakshtramstyles}>Thithi:</span>
                {selectedthithi}
              </Typography>
              <Typography>
                <span className={styles.nakshtramstyles}>Nakshatram:</span>
                {selectedNakshatram}
              </Typography>
              <Typography>
                <span className={styles.nakshtramstyles}>Rahukalam:</span>
                {selectedRahukalam}
              </Typography>
              <Typography>
                <span className={styles.nakshtramstyles}>Durmuhurthum:</span>
                {selectedDurmuhurthum}
              </Typography>
            </Grid>
            <ScheduleEventsTemplate itemList={todayScheduleList} />
          </div>
        </div>
      </Dialog>
    );
  };

  return (
    <div>
      <Toaster />
      <table className={styles.middleContainer} style={{ width: "100%" }}>
        {isMobile ? WeeksConatinerForMobileView() : WeeksConatiner()}
        {tableMainCalenderContent()}
      </table>
      {dialogPopUp()}
    </div>
  );
};

export default CalenderData;
